<template>
  <div class="row">
    <alert-compact :message="message" :errors="errors"></alert-compact>

    <ibox v-if="Object.keys(notice).length">
      <template slot="title">
        {{notice.name}}
      </template>
      <div slot="tools" class="pull-left">
      </div>
      <div slot="body">
        <div class="row">
          <div class="col-sm-12">
            <p class="forum-sub-title" v-html="notice.note">
            </p>
          </div>
          <div class="col-sm-12">

            <table class="table">
              <tr>
                <td>Part</td>
                <td>
                  <button class="btn btn-xs " v-bind:class="{'btn-info' :part==='html'}"
                          v-on:click="updatePart('html')">HTML
                  </button>
                  <button class="btn btn-xs " v-bind:class="{'btn-info' :part==='text'}"
                          v-on:click="updatePart('text')">TEXT
                  </button>
                </td>
              </tr>
              <tr>
                <td>File</td>
                <td>
                  <template v-for="pattern in patterns">
                    <template v-for="template in templates" v-if="template.pattern==pattern">
                      <button class="btn btn-xs " v-bind:class="{'btn-info' :file===template.file}"
                              v-on:click="updateFile(template.file,pattern)" style="margin-right: 4px">{{template.name}}
                      </button>
                    </template>
                    <br>
                  </template>
                </td>
              </tr>
            </table>

          </div>
          <div class="col-sm-6 " style="height: 100%">
            <div class="mail-box-header">

              <label>{{note}}</label>
            </div>

            <div class="mail-box" style="height: 100%">
              <textarea class="form-control" style="height: 500px" v-model="body"></textarea>
            </div>
          </div>
          <div class="col-sm-6" style="height: 100%;">
            <div class="mail-box-header">
              <div class="mail-tools tooltip-demo m-t-md">
                <h3>
                  <span class="font-normal">Subject: </span>{{subject}}
                </h3>
              </div>
            </div>
            <div class="mail-box" style="height: 500px ;overflow: scroll ">
              <iframe class="mail-body" style="width: 100%;height: 100%;padding: 0;margin: 0" :srcdoc="output">
              </iframe>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="pull-right">
          <button class="btn btn-primary" v-on:click="saveModal=true">保存</button>
          <button class="btn btn-primary" v-on:click="testModal=true">テスト配信</button>
        </div>
        <div class="clearfix"></div>
      </div>
    </ibox>
    <modal v-if="testModal">
      <template slot="header">テスト配信</template>
      <template slot="body">
        <div class="form-group">
          <label>送信先</label>
          <textarea class="form-control" v-model="to" rows="5"></textarea>
        </div>
      </template>
      <template slot="footer">
        <button class="btn " v-on:click="testModal=false">キャンセル</button>
        <button class="btn btn-primary" v-on:click="delivery">テスト配信</button>
      </template>
    </modal>
    <modal v-if="saveModal">
      <template slot="header">保存確認</template>
      <template slot="body">
        <div class="form-group">
          <p>{{notice.name}}のテンプレートを保存しますか？</p>
        </div>
      </template>
      <template slot="footer">
        <button class="btn " v-on:click="saveModal=false">キャンセル</button>
        <button class="btn btn-primary" v-on:click="saveNotice">保存</button>
      </template>
    </modal>
  </div>
</template>

<script>
  import Api from '../../service/Api.vue'

  export default {
    data () {
      return {
        // Common
        message: false,
        errors: false,
        // 通知ベース
        alias: this.$route.params.alias,
        notice: {},
        patterns: {},
        testModal: false,
        saveModal: false,
        // テンプレート選択
        templates: [],
        part: 'html',
        file: '',
        pattern: '',
        note: '',
        // 表示制御系
        subject: '',
        to: '',
        lock: false,
        body: '',
        beforeBody: '',
        output: ''
      }
    },
    created: function () {
      this.init()
    },
    watch: {
      'body': function () {
        var templates = this.templates
        var file = this.file
        var body = this.body
        var part = this.part
        templates.forEach(function (row, index) {
          if (row.file === file) {
            if (part === 'html') {
              row.html = body
            } else {
              row.text = body
            }
            templates[index] = row
          }
        })
        this.templates = templates
        // プレビュー
        this.updateOutput()
      }
    },
    methods: {
      // 初回読み込み
      init: function () {
        Api.notice.get(this.alias).then(this.initResult).catch(this.initResult)
      },
      initResult (response) {
        var data = {}
        if (response.response && response.response.data) {
          data = response.response.data
          this.errors = data.errors
          return
        }
        if (response.errors) {
          this.errors = response.data.errors
        }
        this.notice = response.data.notice
        this.subject = response.data.notice.subject
        this.templates = response.data.notice.templates
        this.patterns = response.data.notice.patterns
        this.html = response.data.notice.html
        if (this.templates[0]) {
          this.note = this.templates[0].note
          this.file = this.templates[0].file
          this.pattern = this.templates[0].pattern
          if (this.html) {
            this.body = this.templates[0].html
          } else {
            this.body = this.templates[0].text
          }
        }
        this.updateOutput()
      },
      // 保存
      saveNotice: function () {
        Api.notice.put(this.alias, {templates: this.templates}).then(this.resultSaveNotice).catch(this.resultSaveNotice)
      },
      // 保存
      resultSaveNotice: function (response) {
        this.saveModal = false
        var data = {}
        if (response.response && response.response.data) {
          data = response.response.data
          this.message = false
          this.errors = data.errors
          return
        }
        this.message = 'テンプレートを保存しました。'
        this.errors = false
      },
      // テスト配信
      delivery: function () {
        Api.notice.delivery({
          to: this.to,
          alias: this.alias,
          part: this.part,
          pattern: this.pattern,
          templates: this.templates
        }).then(this.resultDelivery).catch(this.resultDelivery)
      },
      resultDelivery: function (response) {
        this.testModal = false
        var data = {}
        if (response.response && response.response.data) {
          data = response.response.data
          this.message = false
          this.errors = data.errors
          return
        }
        this.message = 'テスト配信をしました。'
        this.errors = false
      },
      updateOutput: function () {
        if (this.lock === false) {
          this.lock = true
          this.beforeBody = this.body
          Api.notice.preview({
            alias: this.alias,
            part: this.part,
            pattern: this.pattern,
            templates: this.templates
          }).then(this.resultOutput).catch(this.resultOutput)
        }
      },
      resultOutput: function (result) {
        this.lock = false
        if (result.data) {
          this.subject = result.data.subject
          this.output = result.data.body
          if (this.beforeBody !== this.body) {
            this.updateOutput()
          }
        }
      },
      // プレビュー
      updatePart: function (val) {
        this.part = val
        this.resetEditor()
      },
      updateFile: function (val, pattern) {
        this.file = val
        this.pattern = pattern
        this.resetEditor()
      },
      // エディタのテキストを選択状態へ変更
      resetEditor () {
        var templates = this.templates
        var file = this.file
        var body = ''
        var part = this.part
        var note = ''
        templates.forEach(function (row, index) {
          if (row.file === file) {
            if (part === 'html') {
              body = row.html
            } else {
              body = row.text
            }
            note = row.note
          }
        })
        this.body = body
        this.note = note
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Edit.vue?dc30f9c4